import { Box, Dot } from '@factorialco/deprecated-design-system'

const Line = () => {
  return (
    <Box flexDirection="column" alignItems="center" justifyContent="center">
      <Dot />
      <Box flexDirection="row" alignItems="center">
        <Box
          width="s1"
          height="s16"
          border={{
            left: {
              width: 's2',
              style: 'solid',
              color: 'grey400',
            },
          }}
          borderRadius={{ all: 'abs012' }}
        />
      </Box>
    </Box>
  )
}

export default Line
